import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3328">
      <Navbar data-id="element-3329" />
      <main data-id="element-3330">
        <ConsularAffairs data-id="element-3331" />
      </main>
      <Footer data-id="element-3332" />
      <FeedbackPopup data-id="element-3333" />
    </div>;
}